export const CHECKOUT_URL = 'https://biblioteca-arteterapia.impultienda.ar/checkout'

export const handleCheckout = (e?: React.MouseEvent) => {
  if (e) e.preventDefault()

  if (typeof window !== 'undefined' && window.fbq) {
    window.fbq('track', 'InitiateCheckout')
    // Give the pixel beacon a moment to leave before navigating away
    setTimeout(() => {
      window.location.href = CHECKOUT_URL
    }, 150)
    return
  }

  window.location.href = CHECKOUT_URL
}
